import { debounce } from 'lodash-es';
import { EventBasedStore } from '../utils/EventBasedStore';
import { isBrowser } from '../utils/trick';

type State = {
  width: number;
  height: number;
};

const compute = ({ width }: State) => {
  return {
    xsm: width <= 376,
    sm: width <= 640,
    md: width <= 768,
    lg: width <= 1024,
    xl: width <= 1280,
    is2xl: width <= 1536,
  };
};

export type Computed = ReturnType<typeof compute>;

export const screeSizeStore = new EventBasedStore<State, Computed>(
  isBrowser
    ? {
        width: window.innerWidth,
        height: window.innerHeight,
      }
    : {
        // TODO：暂时ssr 默认大屏
        width: 1920,
        height: 1080,
      },
  compute,
  () => {
    if (isBrowser) {
      window.addEventListener(
        'resize',
        debounce(() => {
          screeSizeStore.setState({
            width: window.innerWidth,
            height: window.innerHeight,
          });
        }, 200),
      );
    }
  },
);

export const useScreen = screeSizeStore.useStoreState.bind(screeSizeStore);
